import tinycolor from 'tinycolor2'

import { getColorStylePropertyValue } from './styles'

export function getColorWithOpacity(color, opacity = 0.1) {
  return tinycolor(getColorStylePropertyValue(color))
    .setAlpha(opacity)
    .toHex8String()
}

export function isWhiteColor(color) {
  const noramlizedColor = tinycolor(color)

  if (!noramlizedColor.isValid()) {
    return false
  }

  return noramlizedColor.toHexString() === '#ffffff'
}

export function isBlackColor(color) {
  const normalizedColor = tinycolor(color)

  return (
    normalizedColor.isValid() && normalizedColor.toHexString() === '#000000'
  )
}

export function getHSVColorSaturation(x, width) {
  return x / width
}

export function getHSVColorValue(y, height) {
  return 1 - y / height
}
